import { render } from "./footer.vue?vue&type=template&id=06645320"
const script = {}

import exportComponent from "D:\\repository\\vue\\yadino-marketplace\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__